// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"Skills_boxStyle__3_OVl","rightBox":"Skills_rightBox__1EI6f","iconBox":"Skills_iconBox___1mk7","img":"Skills_img___GW3O","skillsTitle":"Skills_skillsTitle__dgrA-"};